import { produce } from 'immer';

import { AddNewInternalBanner } from '../../../actions/bannersEdit/internal/addNewInternalBanner';
import { createInternalEditedBanner } from '../../../service/InternalBannerHelpers/InternalBannerHelpers';
import { EditInternalBannersState } from '../../../typings/internalBannersEditState';

export function addNewInternalBanner(
    state: EditInternalBannersState,
    action: AddNewInternalBanner
): EditInternalBannersState {
    return produce(state, draft => {
        const bannerId = action.bannerId;
        const group = draft.groupBannersList[action.groupId];

        draft.banners[bannerId] = createInternalEditedBanner({
            id: bannerId,
            isNew: true,
            group: {
                id: group.groupId,
                name: group.groupName,
                status: group.status,
                canEdit: group.canEdit,
                type: group.type
            },
            campaign: group.campaign
        });

        draft.bannersDraft[bannerId] = {};

        group.bannersIds.push(bannerId);
        group.bannersTotal += 1;
    });
}
